import { RelationshipEntity } from '../entities/relationship-entity';

export default class State {
  items: Array<RelationshipEntity> = [];
}
